import type {ReactElement} from 'react';
import {useState} from 'react';
import styles from './share-social-post-in-team-toggler.module.scss';
import {ShareInTeamBarState} from '@Components/share-in-team-toggle-bar/share-in-team-toggle-bar.types';
import {ShareInTeamToggleBar} from '../share-in-team-toggle-bar/share-in-team-toggle-bar';
import {isUserPremium} from '@Libraries/user.library';
import {noop} from '@Utils/general.util';
import type {SocialPost} from '@Components/social-media/post.vo';
import {shareSocialMediaPostInTeam} from '@Libraries/social-media-post.library';
import {ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';

interface ShareSocialPostInTeamTogglerProps {
  post: SocialPost;
  onStateUpdate?: (state: ShareInTeamBarState) => void;
  gaEvent?: string;
}

export function ShareSocialPostInTeamToggler({post, onStateUpdate = noop, gaEvent = ''}: ShareSocialPostInTeamTogglerProps): ReactElement<any> {
  const getToggleStateByPostState = (): ShareInTeamBarState => {
    if (!isUserPremium()) {
      return ShareInTeamBarState.UPSELLING;
    }

    if (post.isSharedInTeam) {
      return ShareInTeamBarState.ACTIVE;
    }

    return ShareInTeamBarState.INACTIVE;
  };

  const [isLoading, setIsLoading] = useState(false);
  const [toggleState, setToggleState] = useState(getToggleStateByPostState());

  const updateSharingStatus = async (shareInTeamState: ShareInTeamBarState): Promise<void> => {
    let isSharedInTeam = false;
    if (shareInTeamState === ShareInTeamBarState.ACTIVE) {
      isSharedInTeam = true;
    }

    setIsLoading(true);
    await shareSocialMediaPostInTeam(isSharedInTeam, post.id);
    setIsLoading(false);
    setToggleState(shareInTeamState);
    onStateUpdate(shareInTeamState);

    if (isSharedInTeam && gaEvent) {
      window.PMW.gtm.trackGA4CustomEvent(gaEvent);
    }
  };

  return (
    <ShareInTeamToggleBar
      state={toggleState}
      isCurrentlyLoading={isLoading}
      onStateUpdate={(shareInTeamState: ShareInTeamBarState): void => {
        void updateSharingStatus(shareInTeamState);
      }}
      customClasses={styles.backgroundTransparent}
      toggleSize={ToggleSwitchV2Size.MEDIUM}
      shareInTeamIcon={<Icon icon="icon-team" size={IconSize.SIZE_ICON_16} type={IconType.NONE} />}
    />
  );
}
